import React from "react";

// MUI
import SvgIcon from '@mui/material/SvgIcon';

// Types
import { SvgIconProps } from "@mui/material";

function SlapIcon(props: SvgIconProps) {
  return <SvgIcon {...props} >
    <svg version="1.1" id="SlapIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="100px" height="100px" viewBox="0 0 100 100"
      style={{
        // @ts-ignore
        enableBackground: "new 0 0 100 100"
      }}
      xmlSpace="preserve">
      <path fill="#FFFFFF" d="M82.9,66.4h-3.1l-0.9-1.8c-0.5-1-1.5-4-1.9-12.4c-0.3-6.3-1.4-11.5-3.5-15.9c-2.1-4.5-5.3-8.1-9.3-10.6
	c-5.4-3.3-11.9-4.5-18.7-4.9l-2.2-0.1c-1,0-24.4-0.1-24.4-0.1v9.9h5.2c3.3,0,6.1,1,8,2.9c1.1,1.1,2,3.2,2.6,6
	c0.7,3.3,1.1,7.7,1.1,13l0,0c0,1,0,4.4,0.3,8l0,0c0.2,2.3,0.5,4.2,0.8,5.7c-0.5,0.2-1,0.2-1.5,0.2c-0.7,0-1.4-0.2-2-0.4
	c-1.6-0.7-3.4-1.1-5.3-1.1c-1.8,0-3.6,0.4-5.2,1.1c-0.6,0.3-1.3,0.4-2,0.4h-3.8v13h3.8c1.7,0,3.5-0.4,5.1-1.1l0,0
	c0.7-0.3,1.4-0.5,2.1-0.5s1.4,0.2,2,0.5h0.1c1.6,0.7,3.4,1.1,5.1,1.1s3.5-0.4,5.1-1.1h0.1c0.6-0.3,1.3-0.5,2.1-0.5
	c0.7,0,1.4,0.2,2.1,0.5l0,0c1.6,0.7,3.4,1.1,5.1,1.1c1.7,0,3.5-0.4,5.1-1.1l0,0c0.7-0.3,1.4-0.5,2.1-0.5c0.7,0,1.4,0.2,2.1,0.5l0,0
	c1.6,0.7,3.4,1.1,5.1,1.1c1.8,0,3.5-0.4,5.1-1.1h0.1c0.6-0.3,1.4-0.5,2.1-0.5s1.4,0.2,2.1,0.5l0,0c1.6,0.7,3.4,1.1,5.1,1.1h3.8
	L82.9,66.4L82.9,66.4z"/>
      <g>
        <path fill="#3CAA78" d="M34.7,30.7c3.3,3.3,4.9,10.4,4.9,21.7c0,0.2,0,3.8,0.3,7.7c0.2,2.5,0.5,4.3,0.8,5.7c0.6-0.2,1.3-0.2,2-0.2
		c0.6,0,1.1,0.1,1.6,0.2c-0.7-2.5-1.2-7.9-1.2-13.3c0-11.4-1.6-18.8-4.9-23.1c1,0.4,1.9,0.9,2.7,1.6c1.4,1.2,5.8,4.9,6.2,21.5
		c0.2,7.8,1,12.2,1.9,14.6c0.3,0,0.7,0.1,1,0.1c0.9,0,1.8-0.1,2.6-0.4c-0.8-1.5-1.7-6-2-14.4c-0.3-11.8-2.6-18.6-5.9-22.5
		c6,2.6,9.4,8.6,9.9,22.7c0.2,5.7,0.7,10,1.6,13.1c0.3,0,0.7-0.1,1-0.1c1,0,2,0.2,2.9,0.5c-0.8-2-1.7-6-2-13.7
		c-0.4-11.2-2.7-17.9-6.5-21.9c0.8,0.4,1.5,0.8,2.2,1.2c5.2,3.5,7.9,10.1,8.3,20.8c0.2,4.8,0.7,10.7,2.3,14.7h0.1
		c1.2,0,2.4-0.3,3.4-0.7c-0.9-1.8-2-5.7-2.3-14.1c-0.4-10.5-3-17.1-6.9-21.2c0.6,0.3,1.1,0.5,1.6,0.8c5.9,3.6,8.8,10.1,9.3,20.5
		c0.3,5.8,0.8,10.1,1.7,13.1c0.1,0,0.3,0,0.4,0c1.3,0,2.5,0.3,3.7,0.8c-1.1-2-1.9-6-2.3-14C72.6,40.8,69,33.2,62.1,29
		c-6.5-4-15.3-4.5-23.9-4.5h-12h-3.6v2.3H24C28.4,26.7,32.1,28.1,34.7,30.7L34.7,30.7z"/>
        <path fill="#3CAA78" d="M79.1,75.5c-1.3,0-2.5-0.3-3.6-0.8s-2.4-0.8-3.7-0.8c-1.3,0-2.6,0.3-3.7,0.8s-2.3,0.8-3.6,0.8
		c-1.3,0-2.5-0.3-3.6-0.8s-2.4-0.8-3.7-0.8s-2.6,0.3-3.7,0.8c-1.1,0.5-2.3,0.8-3.6,0.8s-2.5-0.3-3.6-0.8s-2.4-0.8-3.7-0.8
		s-2.6,0.3-3.7,0.8c-1.1,0.5-2.3,0.8-3.6,0.8s-2.5-0.3-3.6-0.8s-2.4-0.8-3.7-0.8c-1.3,0-2.6,0.3-3.7,0.8s-2.3,0.8-3.6,0.8v-5.4
		c1.3,0,2.5-0.3,3.6-0.8s2.4-0.8,3.7-0.8c1.3,0,2.6,0.3,3.7,0.8s2.3,0.8,3.6,0.8s2.5-0.3,3.6-0.8s2.4-0.8,3.7-0.8s2.6,0.3,3.7,0.8
		c1.1,0.5,2.3,0.8,3.6,0.8s2.5-0.3,3.6-0.8s2.4-0.8,3.7-0.8s2.6,0.3,3.7,0.8c1.1,0.5,2.3,0.8,3.6,0.8c1.3,0,2.5-0.3,3.6-0.8
		s2.4-0.8,3.7-0.8c1.3,0,2.6,0.3,3.7,0.8s2.3,0.8,3.6,0.8V75.5z"/>
      </g>
    </svg>
  </SvgIcon>
}

export default SlapIcon;
